import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight, faPlus, faMinus } from '@fortawesome/free-solid-svg-icons'
import { NavLink } from 'react-router-dom'

const Menu = props => {

    const [open, setOpen] = useState(false)

    const iconStyle = {
        "marginLeft": "10px",
        "float": "right"
    }

    const optionsList = props.list;
    const optionsListKeys = Object.keys(optionsList);
    let route
    let list = optionsListKeys.map((key) => {
        if (key === "international") {
            route = <div className={"submenu " + open} onClick={() => setOpen(!open)}>
                <div className='submenu-name'>
                    {props.t('partials:menu.item.8')}
                    {open ? <FontAwesomeIcon icon={faMinus} style={iconStyle} /> : <FontAwesomeIcon icon={faPlus} style={iconStyle} />}
                </div>
                <ul className="list-unstyled">
                    {
                        Object.keys(optionsList[key]).map(link => {
                            return <li> <NavLink to={props.t(`routes:${link}.path`)} className='d-flex align-items-center justify-content-between'>
                                {props.t('partials:menu.company.international.' + link)}
                                <FontAwesomeIcon icon={faAngleRight} style={iconStyle} />
                            </NavLink></li>;
                        })
                    }
                </ul>
            </div>

        } else {

            route = key === "xchangejob" ?
                <a href='https://xchangejob.com/' target="_blank" rel="noreferrer" className='d-flex align-items-center justify-content-between'>
                    {optionsList[key]}
                    <FontAwesomeIcon icon={faAngleRight} style={iconStyle} />
                </a> :
                <NavLink to={props.t(`routes:${key}.path`)} className='d-flex align-items-center justify-content-between'>
                    {optionsList[key]}
                    <FontAwesomeIcon icon={faAngleRight} style={iconStyle} />
                </NavLink>;
        }
        return (
            <li key={key}>
                {route}
            </li>
        )
    });


    return (
        <div className={["menu", props.isOpen ? 'visible' : 'invisible'].join(" ")}>
            <ul className="list-unstyled">
                {list}
            </ul>
        </div>
    )
}

export default Menu